import React from 'react';
import { ListItemText } from '@mui/material';

interface FixedListItemTextProps {
  primary: React.ReactNode;
  secondary?: React.ReactNode;
}

const FixedListItemText: React.FC<FixedListItemTextProps> = ({ primary, secondary }) => {
  return (
    <ListItemText
      primary={primary}
      secondary={secondary ? <span>{secondary}</span> : undefined}
    />
  );
};

export default FixedListItemText; 